export default __webpack_public_path__ + "static/media/fertilizer.175cf1f7.png";